import React from "react";
import "./Frame302.css";

function Frame302(props) {
  const { className } = props;

  return (
    <div className={`frame-302 ${className || ""}`}>
      <div className="copyrightsohnijunejacom roboto-normal-tundora-12px">copyright@sohnijuneja.com</div>
    </div>
  );
}

export default Frame302;
